import type { KeyboardEvent } from 'react';

import { fg } from '@confluence/feature-gating';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import type { RoutesContextType } from '@confluence/route-manager/entry-points/RoutesContext.ts';

export const createQuickFindSkeletonOnEnter = (push: RoutesContextType['push']) => {
	let generatedRovoJourneyId: string | undefined;

	return (event: KeyboardEvent): void => {
		const input = event.target as HTMLInputElement;
		input.blur();

		const searchParams = new URLSearchParams({ text: input.value });
		if (fg('rovo_search_chat_convergence_instrumentation')) {
			const currentRovoJourneyId = new URLSearchParams(window.location.search).get('rovoJourneyId');
			generatedRovoJourneyId =
				currentRovoJourneyId || generatedRovoJourneyId || crypto.randomUUID();
			searchParams.set('rovoJourneyId', generatedRovoJourneyId);
		}

		push(`${CONTEXT_PATH}/search/?${searchParams.toString()}`);
	};
};
